module.exports = __webpack_public_path__ + "static/media/home_6.4f881874.jpg";